import React from 'react';
// @ts-ignore - Remotion型定義の互換性問題の暫定対応
import { Composition } from 'remotion';
import { ProductShowcase } from './compositions/ProductShowcase';
import { FeatureHighlight } from './compositions/FeatureHighlight';
import { SimpleIntro } from './compositions/SimpleIntro';

/**
 * RemotionRoot component
 * Remotion Studioで使用されるコンポジションの登録
 * BETAフェーズでは @remotion/player を使用するため、このファイルは直接使用されません。
 */
export const RemotionRoot: React.FC = () => {
  return (
    <>
      {/* ProductShowcase: 商品紹介テンプレート（16:9） */}
      <Composition
        id="ProductShowcase16x9"
        component={ProductShowcase}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          productName: 'サンプル商品',
          productImageUrl: 'https://via.placeholder.com/600x400',
          features: ['高品質', '低価格', '迅速配送'],
          ctaText: '今すぐ購入',
          primaryColor: '#3b82f6',
          aspectRatio: '16:9' as const,
        }}
      />

      {/* ProductShowcase: 商品紹介テンプレート（9:16） */}
      <Composition
        id="ProductShowcase9x16"
        component={ProductShowcase}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          productName: 'サンプル商品',
          productImageUrl: 'https://via.placeholder.com/600x400',
          features: ['高品質', '低価格', '迅速配送'],
          ctaText: '今すぐ購入',
          primaryColor: '#3b82f6',
          aspectRatio: '9:16' as const,
        }}
      />

      {/* FeatureHighlight: 特徴強調テンプレート（16:9） */}
      <Composition
        id="FeatureHighlight16x9"
        component={FeatureHighlight}
        durationInFrames={450}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          productName: 'サンプル商品',
          features: [
            { title: '高品質', description: '厳選された素材を使用' },
            { title: '低価格', description: 'お求めやすい価格設定' },
            { title: '迅速配送', description: '最短翌日お届け' },
          ],
          primaryColor: '#10b981',
          aspectRatio: '16:9' as const,
        }}
      />

      {/* FeatureHighlight: 特徴強調テンプレート（9:16） */}
      <Composition
        id="FeatureHighlight9x16"
        component={FeatureHighlight}
        durationInFrames={450}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          productName: 'サンプル商品',
          features: [
            { title: '高品質', description: '厳選された素材を使用' },
            { title: '低価格', description: 'お求めやすい価格設定' },
            { title: '迅速配送', description: '最短翌日お届け' },
          ],
          primaryColor: '#10b981',
          aspectRatio: '9:16' as const,
        }}
      />

      {/* SimpleIntro: シンプルイントロテンプレート（16:9） */}
      <Composition
        id="SimpleIntro16x9"
        component={SimpleIntro}
        durationInFrames={240}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          title: 'ようこそ',
          subtitle: '私たちの商品へ',
          primaryColor: '#8b5cf6',
          aspectRatio: '16:9' as const,
        }}
      />

      {/* SimpleIntro: シンプルイントロテンプレート（9:16） */}
      <Composition
        id="SimpleIntro9x16"
        component={SimpleIntro}
        durationInFrames={240}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          title: 'ようこそ',
          subtitle: '私たちの商品へ',
          primaryColor: '#8b5cf6',
          aspectRatio: '9:16' as const,
        }}
      />
    </>
  );
};
